export default "__VITE_ASSET__tYunopq4__"